import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SOTService } from '../../services';
import { PaymentType } from '../../models';
import { Subscription } from 'rxjs';

@Component({
  selector: "sot-payment",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentComponent implements OnInit, OnDestroy {

  private _paymentChangedSubscription: Subscription;
  private _paymentDoneSubscription: Subscription;
  private _resetAfterPaymentSubscription: Subscription;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
    console.debug("--- sot-payment constructor")
  }
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;

  public ngOnInit(): void {
    console.debug("--- sot-payment ngOnInit")
    const me = this;
    me._paymentChangedSubscription = me._sotService.evPaymentChanged.subscribe(() => { me.paymentChanged() });
    if (me._sotService.GetPayType() == PaymentType.atPOS) {
      me._paymentDoneSubscription = me._sotService.evPaymentDone.subscribe(() => { me.paymentDone() });
      me._resetAfterPaymentSubscription = me._sotService.evResetAfterPayment.subscribe(() => { me.resetAfterPaymentComplete() });
    }
    me.isModeOne = me._sotService.useModeOne();
    me.isModeTwo = me._sotService.useModeTwo();
    me.PushChanges();
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-payment ngOnDestroy")
    if (this._paymentChangedSubscription) {
      this._paymentChangedSubscription.unsubscribe();
    }
    if (this._paymentDoneSubscription) {
      this._paymentDoneSubscription.unsubscribe();
    }
    if (this._resetAfterPaymentSubscription) {
      this._resetAfterPaymentSubscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("SplashscreenComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public get pay_at_terminal(): boolean {
    return this._sotService.GetPayType() == PaymentType.ecTerminal;
  }

  public get pay_at_pos(): boolean {
    return this._sotService.GetPayType() == PaymentType.atPOS;
  }

  public get has_payment_image(): boolean {
    return this._sotService.GetSettings().has_payment_image;
  }

  public get voucher_pay(): boolean {
    return this._sotService.GetPayType() == PaymentType.voucherPay;
  }

  public get payment_image_path(): string {
    return this._sotService.GetSettings().payment_image_path;
  }

  /* sonder bereich, falls per POS gezahlt wird */

  /** reagiert, wenn die zahlungsart gewechselt wurde */
  private paymentChanged(): void {
    const me = this;
    if (me._sotService.GetPayType() == PaymentType.atPOS) {
      me._paymentDoneSubscription = me._sotService.evPaymentDone.subscribe(() => { me.paymentDone() });
      me._resetAfterPaymentSubscription = me._sotService.evResetAfterPayment.subscribe(() => { me.resetAfterPaymentComplete() });
    }
    me.PushChanges();
  }

  /** zeigt und startet damit den countdown, wenn am POS gezahlt wird */
  public show_countdown: boolean = false;

  private paymentDone(): void {
    const me = this;
    me.show_countdown = true;
    me.PushChanges();
  }

  public newOrder(): void {
    this._sotService.GoToOrdertype();
  }

  /** reagiert, wenn das POS mitteilt das der Bon gezogen wurde */
  private resetAfterPaymentComplete(): void {
    this._sotService.GoToStartscreen();
  }

  public countdownStatusChanged(status: "start" | "stop" | "done"): void {
    if (status == "done") {
      console.debug("PaymentComponent countdownStatusChanged done")
      this._sotService.GoToStartscreen();
    } // else ignore
  }
}
